var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66669 9.33325H25.0534C25.4259 9.33327 25.7943 9.41135 26.1349 9.56246C26.4754 9.71357 26.7805 9.93436 27.0305 10.2106C27.2805 10.4868 27.4698 10.8124 27.5863 11.1663C27.7027 11.5202 27.7438 11.8945 27.7067 12.2653L26.9067 20.2653C26.8409 20.9233 26.5329 21.5333 26.0426 21.9771C25.5523 22.4208 24.9146 22.6666 24.2534 22.6666H11.52C10.9033 22.6668 10.3056 22.4533 9.82861 22.0624C9.35164 21.6715 9.02489 21.1273 8.90402 20.5226L6.66669 9.33325Z",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3334 28H24M6.66669 9.33333L5.58669 5.00933C5.51446 4.721 5.34796 4.46508 5.11363 4.28221C4.8793 4.09934 4.59059 4.00001 4.29335 4H2.66669L6.66669 9.33333ZM10.6667 28H13.3334H10.6667Z",
    stroke: "#1D1D1D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 9,
    r: 4.5,
    fill: "#FF912B",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.205e9ea96efe122fd74998218b4aa01a.svg";
export { ForwardRef as ReactComponent };